type IconProp = React.HTMLAttributes<SVGElement>;

export const Graphics = {
  highlight: (props: IconProp) => (
    <svg {...props} aria-hidden="true" viewBox="0 0 100 15" preserveAspectRatio="none">
      <path d="M0,10 Q50,0 100,10" stroke="#ec4899" strokeWidth="4" fill="none" />
    </svg>
  ),
  homeIcon: (props: IconProp) => (
    <svg
      {...props}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M11.8314 5.57573L10.6299 4.37572L6.42472 0.175674C6.31207 0.0631898 6.15929 0 6 0C5.84071 0 5.68793 0.0631898 5.57528 0.175674L1.37011 4.37572L0.168634 5.57573C0.059205 5.68889 -0.00134602 5.84046 2.27095e-05 5.99778C0.00139144 6.1551 0.0645704 6.30559 0.175952 6.41683C0.287334 6.52808 0.438006 6.59118 0.595518 6.59255C0.75303 6.59391 0.904778 6.53344 1.01808 6.42414L1.19409 6.24834V10.8C1.19409 11.1182 1.32068 11.4235 1.546 11.6485C1.77132 11.8736 2.07692 12 2.39557 12H4.19779C4.35711 12 4.50991 11.9368 4.62257 11.8243C4.73523 11.7117 4.79852 11.5591 4.79852 11.4V8.99997C4.79852 8.84084 4.86182 8.68822 4.97448 8.5757C5.08714 8.46318 5.23994 8.39996 5.39926 8.39996H6.60074C6.76006 8.39996 6.91286 8.46318 7.02552 8.5757C7.13818 8.68822 7.20148 8.84084 7.20148 8.99997V11.4C7.20148 11.5591 7.26477 11.7117 7.37743 11.8243C7.49009 11.9368 7.64289 12 7.80221 12H9.60443C9.92308 12 10.2287 11.8736 10.454 11.6485C10.6793 11.4235 10.8059 11.1182 10.8059 10.8V6.24834L10.9819 6.42414C11.0952 6.53344 11.247 6.59391 11.4045 6.59255C11.562 6.59118 11.7127 6.52808 11.824 6.41683C11.9354 6.30559 11.9986 6.1551 12 5.99778C12.0013 5.84046 11.9408 5.68889 11.8314 5.57573Z"
        fill="#0093D0"
      />
    </svg>
  ),
  flleIcon: (props: IconProp) => (
    <svg
      {...props}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.60547 10.0039C9.41016 9.37891 9.41406 8.17188 9.52734 8.17188C9.85547 8.17188 9.82422 9.61328 9.60547 10.0039ZM9.53906 11.8477C9.23828 12.6367 8.86328 13.5391 8.42969 14.2969C9.14453 14.0234 9.95312 13.625 10.8867 13.4414C10.3906 13.0664 9.91406 12.5273 9.53906 11.8477ZM5.86328 16.7227C5.86328 16.7539 6.37891 16.5117 7.22656 15.1523C6.96484 15.3984 6.08984 16.1094 5.86328 16.7227ZM12.1875 6.25H17.5V19.0625C17.5 19.582 17.082 20 16.5625 20H3.4375C2.91797 20 2.5 19.582 2.5 19.0625V0.9375C2.5 0.417969 2.91797 0 3.4375 0H11.25V5.3125C11.25 5.82812 11.6719 6.25 12.1875 6.25ZM11.875 12.9609C11.0938 12.4844 10.5742 11.8281 10.207 10.8594C10.3828 10.1367 10.6602 9.03906 10.4492 8.35156C10.2656 7.20312 8.79297 7.31641 8.58203 8.08594C8.38672 8.80078 8.56641 9.80859 8.89844 11.0938C8.44531 12.1719 7.77734 13.6172 7.30469 14.4453C7.30078 14.4453 7.30078 14.4492 7.29688 14.4492C6.23828 14.9922 4.42188 16.1875 5.16797 17.1055C5.38672 17.375 5.79297 17.4961 6.00781 17.4961C6.70703 17.4961 7.40234 16.793 8.39453 15.082C9.40234 14.75 10.5078 14.3359 11.4805 14.1758C12.3281 14.6367 13.3203 14.9375 13.9805 14.9375C15.1211 14.9375 15.1992 13.6875 14.75 13.2422C14.207 12.7109 12.6289 12.8633 11.875 12.9609ZM17.2266 4.10156L13.3984 0.273438C13.2227 0.0976562 12.9844 0 12.7344 0H12.5V5H17.5V4.76172C17.5 4.51562 17.4023 4.27734 17.2266 4.10156ZM14.332 14.0742C14.4922 13.9687 14.2344 13.6094 12.6602 13.7227C14.1094 14.3398 14.332 14.0742 14.332 14.0742Z"
        fill="#EE4197"
      />
    </svg>
  ),
  errorIcon: (props: IconProp) => (
    <svg
      {...props}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      className="shrink-0"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9.0003 6.75017V9.75017M9.0003 12.7502H9.0078M7.96179 2.91897L1.79313 13.5739C1.45097 14.1649 1.2799 14.4604 1.30518 14.7029C1.32724 14.9145 1.43806 15.1067 1.61008 15.2318C1.8073 15.3752 2.14875 15.3752 2.83164 15.3752H15.169C15.8519 15.3752 16.1933 15.3752 16.3905 15.2318C16.5625 15.1067 16.6734 14.9145 16.6954 14.7029C16.7207 14.4604 16.5496 14.1649 16.2075 13.5739L10.0388 2.91896C9.69789 2.33009 9.52743 2.03566 9.30503 1.93677C9.11104 1.85051 8.88957 1.85051 8.69558 1.93677C8.47318 2.03566 8.30272 2.33009 7.96179 2.91897Z"
        stroke="#DC2626"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  document: (props: IconProp) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path
        d="M28.9287 18.2163L18.8358 28.3091L14.2715 28.9305L14.9143 24.3662L24.9859 14.2734L28.9287 18.2163Z"
        stroke="#9C9C9C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.57031 21.4302V3.21596C8.57031 2.62423 9.05001 2.14453 9.64174 2.14453H26.7846C27.3762 2.14453 27.856 2.62423 27.856 3.21596V9.64453"
        stroke="#9C9C9C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7854 21.4297H3.21401C2.62228 21.4297 2.14258 21.9095 2.14258 22.5011V24.644C2.14258 26.4191 3.58166 27.8583 5.35686 27.8583H9.64258"
        stroke="#9C9C9C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12.8555 7.5H23.5698" stroke="#9C9C9C" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.8555 11.7891H20.3555" stroke="#9C9C9C" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  magnifyingGlassCircle: (props: IconProp) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
      <g clipPath="url(#clip0_2988_9721)">
        <path
          d="M15.9997 31.8225C24.2052 31.8225 30.8569 24.963 30.8569 16.5011C30.8569 8.03933 24.2052 1.17969 15.9997 1.17969C7.79435 1.17969 1.14258 8.03933 1.14258 16.5011C1.14258 24.963 7.79435 31.8225 15.9997 31.8225Z"
          stroke="#219F96"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8569 21.2154C18.0128 21.2154 20.5712 18.5771 20.5712 15.3225C20.5712 12.068 18.0128 9.42969 14.8569 9.42969C11.701 9.42969 9.14258 12.068 9.14258 15.3225C9.14258 18.5771 11.701 21.2154 14.8569 21.2154Z"
          stroke="#219F96"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.8566 23.5739L18.9023 19.4961"
          stroke="#219F96"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2988_9721">
          <rect width="32" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  okHand: (props: IconProp) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path
        d="M19.1909 28.5175C20.1865 28.2185 21.1413 27.7233 21.9972 27.026C23.1526 26.0847 23.9881 24.886 24.4808 23.5782C25.0107 22.1712 24.2999 20.6009 22.8927 20.0708C22.4907 19.9194 22.0752 19.8692 21.6745 19.9078C22.0673 19.8171 22.4459 19.6374 22.7796 19.3656C23.9453 18.4159 24.0344 16.2539 23.0847 15.0882C21.3672 12.9801 18.8156 11.9519 16.2936 12.0917L19.1224 5.60618C19.7996 4.05359 19.0732 2.24729 17.5096 1.59582C16.2273 1.06151 14.75 1.46636 13.9778 2.62118C11.8541 5.79721 7.94881 12.2378 7.70558 16.9798C7.37043 23.5137 7.70564 28.5175 7.70564 28.5175"
        stroke="#9C9C9C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3429 18.5142C14.1772 19.4639 14.002 21.1787 14.9517 22.3445C15.9014 23.5102 17.6162 23.6853 18.7819 22.7356C19.1717 22.418 19.4464 22.0218 19.6091 21.5898C19.9428 20.7037 20.689 20.0938 21.5473 19.8958C20.6712 19.9802 19.7706 19.6389 19.1731 18.9053C18.2234 17.7397 16.5085 17.5645 15.3429 18.5142Z"
        stroke="#9C9C9C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3102 12.0977C15.7628 12.1625 14.4605 12.4045 13.6309 12.8539"
        stroke="#9C9C9C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.58618 19.2804C5.66847 14.9927 5.75431 7.94994 5.9569 4.3034C6.03393 2.91633 7.0996 1.81605 8.4754 1.62343C10.1529 1.38856 11.6974 2.57381 11.9045 4.25495V5.96608"
        stroke="#9C9C9C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  shipmentBox: (props: IconProp) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path
        d="M4.81445 6.25H16.0645V23.75H6.06445C5.73293 23.75 5.41499 23.6183 5.18057 23.3839C4.94615 23.1495 4.81445 22.8315 4.81445 22.5V6.25Z"
        stroke="#9C9C9C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16.0645 6.25H26.0645" stroke="#9C9C9C" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M26.0645 13.75V22.5C26.0645 22.8315 25.9328 23.1495 25.6983 23.3839C25.4639 23.6183 25.146 23.75 24.8145 23.75H16.0645"
        stroke="#9C9C9C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0645 6.25L18.8745 12.9813C18.9694 13.2089 19.1297 13.4034 19.335 13.5402C19.5403 13.677 19.7815 13.75 20.0282 13.75H28.2495C28.3524 13.7499 28.4537 13.7245 28.5444 13.6758C28.6351 13.6272 28.7124 13.5569 28.7695 13.4713C28.8263 13.3857 28.8611 13.2874 28.871 13.1852C28.8808 13.0829 28.8652 12.9798 28.8257 12.885L26.0645 6.25"
        stroke="#9C9C9C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.81538 6.25L1.22413 12.6813C1.15966 12.7883 1.1248 12.9105 1.12311 13.0355C1.12142 13.1604 1.15297 13.2836 1.21453 13.3923C1.27608 13.501 1.36543 13.5915 1.47343 13.6543C1.58142 13.7172 1.70418 13.7502 1.82913 13.75H4.81538"
        stroke="#9C9C9C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  partyPopper: (props: IconProp) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <g clipPath="url(#clip0_2988_9850)">
        <path
          d="M4.55776 28.7769L18.872 23.4412C19.2958 23.2917 19.675 23.0377 19.9749 22.7032C20.2748 22.3685 20.4857 21.9637 20.5881 21.5262C20.6906 21.0887 20.6813 20.6325 20.5611 20.1995C20.441 19.7665 20.2139 19.3706 19.9006 19.0484L10.922 10.0699C10.5904 9.759 10.1856 9.53692 9.74523 9.42418C9.30485 9.31145 8.84313 9.31175 8.4029 9.425C7.96265 9.53827 7.55814 9.76085 7.22686 10.0721C6.89557 10.3834 6.64822 10.7733 6.50776 11.2056L1.19348 25.5198C1.04586 25.9835 1.03062 26.4794 1.14946 26.9512C1.26831 27.4233 1.51652 27.8525 1.86617 28.1911C2.21581 28.5297 2.65301 28.7639 3.12854 28.8674C3.60406 28.9709 4.09906 28.9396 4.55776 28.7769Z"
          stroke="#9C9C9C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.6051 15.2783C24.6535 14.7473 23.5392 14.587 22.4766 14.8283"
          stroke="#9C9C9C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.1641 9.65402C21.7709 8.73923 22.0225 7.63418 21.8712 6.54688"
          stroke="#9C9C9C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.7922 1.07031C16.5433 3.37103 16.4445 5.86481 15.5137 8.09888"
          stroke="#9C9C9C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.8566 8.03348C27.2649 8.03348 26.7852 7.55378 26.7852 6.96205C26.7852 6.37032 27.2649 5.89062 27.8566 5.89062C28.4482 5.89062 28.928 6.37032 28.928 6.96205C28.928 7.55378 28.4482 8.03348 27.8566 8.03348Z"
          stroke="#9C9C9C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2988_9850">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  checkCircle: (props: IconProp) => (
    <svg
      {...props}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="78"
      height="78"
      viewBox="0 0 78 78"
      fill="none"
    >
      <circle cx="39" cy="39" r="38" fill="white" stroke="#219F96" strokeWidth="2" />
      <path
        d="M58.3337 26.5L31.7503 53.0833L19.667 41"
        stroke="#219F96"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  insta: (props: IconProp) => (
    <svg
      {...props}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M14.0054 7.26221C10.2788 7.26221 7.27295 10.2681 7.27295 13.9946C7.27295 17.7212 10.2788 20.727 14.0054 20.727C17.7319 20.727 20.7378 17.7212 20.7378 13.9946C20.7378 10.2681 17.7319 7.26221 14.0054 7.26221ZM14.0054 18.3716C11.5972 18.3716 9.62842 16.4087 9.62842 13.9946C9.62842 11.5806 11.5913 9.61767 14.0054 9.61767C16.4194 9.61767 18.3823 11.5806 18.3823 13.9946C18.3823 16.4087 16.4136 18.3716 14.0054 18.3716ZM22.5835 6.98681C22.5835 7.85986 21.8804 8.55713 21.0132 8.55713C20.1401 8.55713 19.4429 7.854 19.4429 6.98681C19.4429 6.11963 20.146 5.4165 21.0132 5.4165C21.8804 5.4165 22.5835 6.11963 22.5835 6.98681ZM27.0425 8.58056C26.9429 6.47705 26.4624 4.61377 24.9214 3.07861C23.3862 1.54346 21.5229 1.06299 19.4194 0.95752C17.2515 0.834473 10.7534 0.834473 8.58545 0.95752C6.48779 1.05713 4.62451 1.5376 3.0835 3.07275C1.54248 4.60791 1.06787 6.47119 0.962402 8.57471C0.839355 10.7427 0.839355 17.2407 0.962402 19.4087C1.06201 21.5122 1.54248 23.3755 3.0835 24.9106C4.62451 26.4458 6.48193 26.9263 8.58545 27.0317C10.7534 27.1548 17.2515 27.1548 19.4194 27.0317C21.5229 26.9321 23.3862 26.4517 24.9214 24.9106C26.4565 23.3755 26.937 21.5122 27.0425 19.4087C27.1655 17.2407 27.1655 10.7485 27.0425 8.58056ZM24.2417 21.7349C23.7847 22.8833 22.8999 23.7681 21.7456 24.231C20.0171 24.9165 15.9155 24.7583 14.0054 24.7583C12.0952 24.7583 7.98779 24.9106 6.26514 24.231C5.1167 23.7739 4.23193 22.8892 3.76904 21.7349C3.0835 20.0063 3.2417 15.9048 3.2417 13.9946C3.2417 12.0845 3.08936 7.97705 3.76904 6.25439C4.22607 5.10596 5.11084 4.22119 6.26514 3.7583C7.99365 3.07275 12.0952 3.23096 14.0054 3.23096C15.9155 3.23096 20.023 3.07861 21.7456 3.7583C22.894 4.21533 23.7788 5.1001 24.2417 6.25439C24.9272 7.98291 24.769 12.0845 24.769 13.9946C24.769 15.9048 24.9272 20.0122 24.2417 21.7349Z"
        fill="#393939"
      />
    </svg>
  ),
  google: (props: IconProp) => (
    <svg
      {...props}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
    >
      <path
        d="M21.62 12.5469C21.62 11.7994 21.5529 11.0806 21.4283 10.3906H11.5V14.4683H17.1733C16.929 15.786 16.1862 16.9025 15.0698 17.65V20.295H18.4767C20.47 18.4598 21.62 15.7573 21.62 12.5469Z"
        fill="#4285F4"
      />
      <path
        d="M11.4995 22.8493C14.3458 22.8493 16.732 21.9053 18.4762 20.2953L15.0693 17.6503C14.1254 18.2828 12.9179 18.6566 11.4995 18.6566C8.75389 18.6566 6.42993 16.8022 5.60098 14.3105H2.0791V17.0418C3.81368 20.487 7.37868 22.8493 11.4995 22.8493Z"
        fill="#34A853"
      />
      <path
        d="M5.60113 14.3103C5.3903 13.6778 5.27051 13.0022 5.27051 12.3074C5.27051 11.6126 5.3903 10.937 5.60113 10.3045V7.57324H2.07926C1.34134 9.04223 0.957357 10.6635 0.958009 12.3074C0.958009 14.0085 1.3653 15.6185 2.07926 17.0416L5.60113 14.3103Z"
        fill="#FBBC05"
      />
      <path
        d="M11.4995 5.95833C13.0472 5.95833 14.4368 6.49021 15.5293 7.53479L18.5529 4.51125C16.7272 2.81021 14.341 1.76562 11.4995 1.76562C7.37868 1.76562 3.81368 4.12792 2.0791 7.57313L5.60098 10.3044C6.42993 7.81271 8.75389 5.95833 11.4995 5.95833Z"
        fill="#EA4335"
      />
    </svg>
  ),
  stepCheck: (props: IconProp) => (
    <svg
      {...props}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M19.1272 8.70145L18.2355 7.80863C18.0469 7.62093 17.9436 7.37067 17.9436 7.1055V5.84225C17.9436 4.19963 16.6071 2.86288 14.9648 2.86288H13.7017C13.4406 2.86288 13.1844 2.75662 12.9997 2.5719L12.107 1.67908C10.9453 0.517129 9.0567 0.517129 7.89495 1.67908L7.0003 2.5719C6.81561 2.75662 6.55943 2.86288 6.29828 2.86288H5.03525C3.39291 2.86288 2.0564 4.19963 2.0564 5.84225V7.1055C2.0564 7.37067 1.95313 7.62093 1.76547 7.80863L0.872803 8.70046C0.309801 9.26356 0 10.0124 0 10.8079C0 11.6034 0.310793 12.3522 0.872803 12.9143L1.76447 13.8071C1.95313 13.9948 2.0564 14.2451 2.0564 14.5102V15.7735C2.0564 17.4161 3.39291 18.7528 5.03525 18.7528H6.29828C6.55943 18.7528 6.81561 18.8591 7.0003 19.0438L7.89296 19.9376C8.47384 20.5176 9.23642 20.8076 9.99901 20.8076C10.7616 20.8076 11.5242 20.5176 12.1051 19.9366L12.9977 19.0438C13.1844 18.8591 13.4406 18.7528 13.7017 18.7528H14.9648C16.6071 18.7528 17.9436 17.4161 17.9436 15.7735V14.5102C17.9436 14.2451 18.0469 13.9948 18.2355 13.8071L19.1272 12.9153C19.6892 12.3522 20 11.6044 20 10.8079C20 10.0114 19.6902 9.26356 19.1272 8.70145ZM14.5229 9.6479L8.56519 13.6204C8.39738 13.7326 8.20475 13.7872 8.0141 13.7872C7.75792 13.7872 7.50372 13.6879 7.31209 13.4962L5.32618 11.51C4.93794 11.1217 4.93794 10.494 5.32618 10.1057C5.71443 9.71742 6.34197 9.71742 6.73022 10.1057L8.14021 11.516L13.4207 7.99534C13.8785 7.69045 14.4941 7.8136 14.7979 8.27044C15.1028 8.72727 14.9796 9.344 14.5229 9.6479Z"
        fill="#EE4197"
      />
    </svg>
  ),
  authCheck: (props: IconProp) => (
    <svg
      {...props}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="45"
      viewBox="0 0 44 45"
      fill="none"
    >
      <path
        d="M40.3337 21.1318V22.8184C40.3314 26.7719 39.0512 30.6187 36.6841 33.7851C34.317 36.9516 30.9897 39.268 27.1985 40.3889C23.4073 41.5099 19.3553 41.3753 15.6469 40.0052C11.9384 38.6351 8.77219 36.103 6.62042 32.7864C4.46865 29.4698 3.44661 25.5466 3.70673 21.6017C3.96686 17.6568 5.4952 13.9017 8.06384 10.8964C10.6325 7.89111 14.1038 5.79664 17.96 4.92537C21.8162 4.0541 25.8508 4.45272 29.462 6.06177M40.3337 8.14128L22.0003 26.4929L16.5003 20.9929"
        stroke="#42A77F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  pdfIcon: (props: IconProp) => (
    <svg {...props} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.09912 5.53474C10.1332 4.63578 7.4267 21.5008 4.80318 19.3021C3.13328 17.9025 8.7227 15.6745 12.7429 15.134C9.32336 12.0904 5.10652 6.12512 7.09912 5.53474Z"
        stroke="#393939"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 13V8L16 1H3C2.46956 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46956 1 3V25C1 25.5304 1.21071 26.0392 1.58579 26.4142C1.96086 26.7892 2.46956 27 3 27H10"
        stroke="#393939"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5077 20.816C27.1641 21.4824 27.1641 22.5176 26.5077 23.184C25.0513 24.6626 22.3165 27 19.5816 27C16.8467 27 14.1118 24.6626 12.6554 23.184C11.999 22.5176 11.999 21.4824 12.6554 20.816C14.1118 19.3374 16.8467 17 19.5816 17C22.3165 17 25.0513 19.3374 26.5077 20.816Z"
        stroke="#393939"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5811 23C20.1334 23 20.581 22.5522 20.581 22C20.581 21.4478 20.1334 21 19.5811 21C19.0288 21 18.5811 21.4478 18.5811 22C18.5811 22.5522 19.0288 23 19.5811 23Z"
        stroke="#393939"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  configureIcon: (props: IconProp) => (
    <svg
      {...props}
      className="shrink-0"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <g clipPath="url(#clip0_3409_28493)">
        <path
          d="M5.04667 10.3355C3.81108 11.5793 1.71137 11.9911 0.5 10.7475C2.11516 9.07573 0.5 8.26815 1.71137 7.05678C1.92407 6.81984 2.18286 6.62876 2.47191 6.49522C2.76097 6.36168 3.07421 6.28849 3.39251 6.28011C3.71081 6.27174 4.02747 6.32835 4.32315 6.4465C4.61882 6.56465 4.8873 6.74185 5.11218 6.96728C5.33705 7.1927 5.51359 7.46161 5.63102 7.75757C5.74845 8.05354 5.80429 8.37034 5.79514 8.68861C5.78598 9.00689 5.71202 9.31996 5.57778 9.60868C5.44354 9.89741 5.25183 10.1557 5.01437 10.3678L5.04667 10.3355Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.89258 6.31389L8.17672 1.53603C8.78567 0.851451 9.8849 0.817559 10.5349 1.46334C11.181 2.11333 11.147 3.21259 10.4622 3.82148L5.73246 8.05668"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.61025 8.34454L9.8264 7.78656C9.86285 7.69208 9.92699 7.61082 10.0104 7.55342C10.0938 7.49601 10.1926 7.46514 10.2939 7.46484H10.7061C10.8074 7.46514 10.9062 7.49601 10.9896 7.55342C11.073 7.61082 11.1371 7.69208 11.1736 7.78656L11.3898 8.34454L12.1237 8.7668L12.7168 8.67631C12.8156 8.66291 12.9161 8.67916 13.0056 8.72302C13.0952 8.76688 13.1696 8.83636 13.2195 8.92263L13.4206 9.27451C13.4721 9.36215 13.4959 9.46336 13.4887 9.56477C13.4815 9.66618 13.4438 9.76303 13.3804 9.84254L13.0134 10.31V11.1546L13.3904 11.6221C13.4538 11.7016 13.4916 11.7985 13.4987 11.8999C13.5059 12.0013 13.4822 12.1025 13.4307 12.1901L13.2296 12.542C13.1797 12.6283 13.1052 12.6978 13.0157 12.7416C12.9262 12.7855 12.8257 12.8017 12.7269 12.7883L12.1337 12.6979L11.3998 13.1201L11.1837 13.6781C11.1472 13.7726 11.0831 13.8538 10.9996 13.9112C10.9162 13.9686 10.8174 13.9995 10.7162 13.9998H10.2939C10.1926 13.9995 10.0938 13.9686 10.0104 13.9112C9.92699 13.8538 9.86285 13.7726 9.8264 13.6781L9.61025 13.1201L8.87632 12.6979L8.28315 12.7883C8.18438 12.8017 8.08386 12.7855 7.99435 12.7416C7.90484 12.6978 7.8304 12.6283 7.78047 12.542L7.57939 12.1901C7.52787 12.1025 7.50413 12.0013 7.51131 11.8999C7.51849 11.7985 7.55625 11.7016 7.61961 11.6221L7.98657 11.1546V10.31L7.60955 9.84254C7.5462 9.76303 7.50843 9.66618 7.50126 9.56477C7.49408 9.46336 7.51781 9.36215 7.56934 9.27451L7.77041 8.92263C7.82034 8.83636 7.89479 8.76688 7.9843 8.72302C8.07381 8.67916 8.17433 8.66291 8.2731 8.67631L8.86627 8.7668L9.61025 8.34454Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10.7324C10 10.865 10.0527 10.9922 10.1464 11.086C10.2402 11.1797 10.3674 11.2324 10.5 11.2324C10.6326 11.2324 10.7598 11.1797 10.8536 11.086C10.9473 10.9922 11 10.865 11 10.7324C11 10.5998 10.9473 10.4726 10.8536 10.3789C10.7598 10.2851 10.6326 10.2324 10.5 10.2324C10.3674 10.2324 10.2402 10.2851 10.1464 10.3789C10.0527 10.4726 10 10.5998 10 10.7324Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3409_28493">
          <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  ),
};
